<template>
  <UiPCheckbox
    ref="label"
    class="boolean-filter"
    :label="settings.name"
    tabindex="-1"
    :disabled="disabled"
    :active="active"
    :value="value"
    :label-class="labelClass"
    @change="onChange"
  />
</template>

<script lang="ts">
import type { BooleanFilter } from '~/interfaces/api';

export default defineComponent({
  name: 'BooleanFilter',
  props: {
    settings: {
      type: Object as () => BooleanFilter,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emitPosition: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: 'body-m-regular',
    },
  },
  emits: ['onChange', 'position'],
  setup(props, { emit }) {
    const label = ref();
    const active = computed(() => {
      if ('active' in props.settings) return !!props.settings.active;
      return true;
    });

    function onChange(): void {
      emit('onChange', {
        id: props.settings.id ? props.settings.id.toString() : 0,
        val: props.value ? undefined : true,
        queryVal: props.value ? undefined : true,
      });
      if (props.emitPosition && label.value?.$el) {
        const { right, top, height } = label.value.$el.getBoundingClientRect();
        emit('position', { right, top: top + height / 2 + window.scrollY });
      }
    }

    return {
      onChange,
      label,
      active,
    };
  },
});
</script>
